
export const storeOrderLog = async (orderID, currentUser, description, notes) => {

    //ENV VARIABLE
    const apiUrl = process.env.REACT_APP_API_URL;
    const backendAPI_Key = process.env.REACT_APP_API_KEY;
    
    //WRITE LOG ENDPOINT
    let endpoint = "writeOrderLog";


    //
    let rawBody = {
        "orderID": orderID,
        "description": description,
        "notes": notes,
        "user": currentUser
    };

    
    //
    const requestBody = JSON.stringify(rawBody);
    

    //
    let response = await fetch(apiUrl + endpoint,
    {
        method: "POST",
        headers: {"Content-Type": "application/json", "X-API-KEY" : backendAPI_Key},
        body: requestBody
    });

    let responseContent = await response.json();


} //END METHOD

